export default __webpack_public_path__ + "static/media/letter-jumble.a2892c63.svg";